module.exports = __webpack_public_path__ + "img/fbxq-title.dc7f60e1.png";